module.exports = __webpack_public_path__ + "img/light-mode-mobile.664f92ef.svg";